import { ConfirmDeleteAlert } from "../../../../../ConfirmAlert";
import { PlaylistHelper } from "../../../../../modules/DigitalSign/Playlist/PaylistHelper";
import { BOOKINGSTATUS, LOCALSTORAGE_KEY, MEDIACATEGORIES, MODULE, ROLETYPE, TRANSMISSION_PUBLISH_STATUS } from "../../../../constant/constant";
import { utility } from "../../../../utility/utilityProvider";

export const collectionMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        props?.module && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        }
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionQuickEditMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
      ]
    }
  ]
  return menu;
}

export const seriesMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        { label: 'Show Series', icon: "pi pi-fw pi-eye", command: () => props.showSeasons(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.MEDIA_EPISODE_SERIES,
            path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_SERIES + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        { label: 'Transmissions', icon: 'pi pi-fw pi-sitemap', command: () => props.onShowTransmissions(props.dataItem) },
        isAutoCreateMAMAssetOnVersion && { label: 'Ingest MAM ( WO )', icon: 'pi pi-fw pi-file-excel', command: () => props.createMAMAssetAndWO(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionQuickEditWithoutDeleteMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Fast Segmentation', icon: "pi pi-fw pi-bolt", command: () => props.onFastSegmentation({ ...props.dataItem }) },
        props?.module == MODULE.MEDIA_EPISODE_PROGRAM && { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionCampaignMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Show Spots', icon: 'pi pi-fw pi-server', command: () => props.toNavigate({ ...props.dataItem, path: '/home/ShowSpots' }) },
        { label: 'Show Secondary Event Spots', icon: 'pi pi-fw pi-server', command: () => props.toSEBookingNavigate({ ...props.dataItem, path: '/home/showSecondaryEventSpots' }) },
        { label: 'Change Status', icon: 'pi pi-fw pi-pencil', command: () => props.setCampaignStatus(props.dataItem) },
        {
          label: 'Show Logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.CAMPAIGN,
            path: ('/home/AuditLog' + "?module=" + MODULE.CAMPAIGN + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        {
          label: 'Show Booking logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate(
            {
              Module: MODULE.BOOKING,
              path: ('/home/AuditLog' + "?module=" + MODULE.BOOKING + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
            })
        },
        {
          label: 'Show Spots logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate(
            {
              Module: MODULE.SHOW_SPOTS,
              path: ('/home/AuditLog' + "?module=" + MODULE.SHOW_SPOTS + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
            }
          )
        },
        { label: 'Telecast Report', icon: 'pi pi-fw pi-download', command: () => props.exportTelecastReport(props.dataItem) }
      ]
    }
  ]
  return menu;
}

export const schedulerDeleteModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => props.onDelete(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionMediaMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
        props?.module && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        }
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionJobsMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        // { label: 'Show', icon: 'pi pi-fw pi-eye', command: () => props.toNavigate({...props.dataItem, path :`/home/Jobs/${props.dataItem.SID}`,attachMedia:false})},
        { label: 'Show', icon: 'pi pi-fw pi-eye', command: () => props.enterEdit({ ...props.dataItem, copy: false, attachMedia: false }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Attach Media', icon: 'pi pi-fw pi-paperclip', command: () => props.enterEdit({ ...props.dataItem, copy: false, attachMedia: true }) },

      ]
    }
  ]
  return menu;
}
export const collectionUserMenuModel = (props) => {

  let currentUser = utility.getValue(LOCALSTORAGE_KEY.userData);
  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Create From', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
      ]
    }
  ]

  if (currentUser.RoleType != undefined && (currentUser.RoleType.ID == ROLETYPE.SuperAdmin || currentUser.RoleType.ID == ROLETYPE.Admin)) {
    menu[0].items.push({ label: 'Reset Password', icon: "fa-solid fa-wrench", command: () => props.onResetPassword(props.dataItem) });
    menu[0].items.push({ label: 'Kill User Session', icon: "fa-solid fa-power-off", command: () => props.onKillUserSession(props.dataItem) });
  }
  return menu;
}

export const ChannelMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  let isDefault = props?.dataItem?.IsDefault ? props?.dataItem?.IsDefault : false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Set As Default', icon: 'pi pi-fw pi-check-circle', command: () => props.setAsDefault(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const contractTitleMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.onEditContractTitle({ ...props.dataItem, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Edit Black Out Date', icon: 'pi pi-fw pi-stop-circle', command: () => props.onEditBlackOutDate({ ...props.dataItem }) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onRemoveContractTitle(props.dataItem), () => { }) },
      ]
    }
  ]

  return menu;
}

export const seasonMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false }), prevPath: `&index=${props.dataIndex}` },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Publish to Ott', icon: "pi pi-fw pi-check-square", command: () => props.publish(props.dataItem._id) },
        { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        { label: 'Show Episodes', icon: "pi pi-fw pi-eye", command: () => props.showEpisodes(props.dataItem) },
        { label: 'Export Seg.', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportSegmentationData({ ...props.dataItem, history: false }) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.MEDIA_EPISODE_SEASON,
            path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_SEASON + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        { label: 'Transmissions', icon: 'pi pi-fw pi-sitemap', command: () => props.onShowTransmissions(props.dataItem) },
        { label: 'Setting', icon: "pi pi-fw pi-cog", command: () => props.mediaEpisodeSetting(props.dataItem) },
        isAutoCreateMAMAssetOnVersion && { label: 'Ingest MAM ( WO )', icon: 'pi pi-fw pi-file-excel', command: () => props.createMAMAssetAndWO(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const OttMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.OTTMENU,
            path: ('/home/AuditLog' + "?module=" + MODULE.OTTMENU + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Name)
          })
        },
      ]
    }
  ]
  return menu;
}

export const collectionMenuModelAsDefualt = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  let showLogs = props.showLogs ?? false;
  let isDefault = props?.dataItem?.IsDefault ? props?.dataItem?.IsDefault : false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: 'Set As Default', icon: 'pi pi-fw pi-check-circle', command: () => props.setAsDefault(props.dataItem) },
        showLogs && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        }
      ].filter(Boolean)
    }
  ]

  return menu;
}

export const collectionMMCQuickEditWithoutDeleteMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'MEC', icon: "pi pi-fw pi-file-excel ", command: () => props.exportMECXML({ ...props.dataItem, exportMEC: true, history: false }) },
        { label: 'MMC', icon: "pi pi-fw pi-file-excel ", command: () => props.exportMMCXML({ ...props.dataItem, mmcAndMec: true, history: false }) },
        { label: 'Ott Package Delivery Schedule', icon: "pi pi-fw pi-flag-fill ", command: () => props.ottPackageDeliverySchedule({ ...props.dataItem, mmcAndMec: false, history: false }) },
      ]
    }
  ]
  return menu;
}

export const collectionPageMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: 'Tv Preview', icon: 'fa-fw fa-solid fa-television', command: () => props.preview({ ...props.dataItem, isMobile: false }) }, // pi-trash
        { label: 'Mobile Preview', icon: 'pi pi-fw pi-mobile', command: () => props.preview({ ...props.dataItem, isMobile: true }) }, // pi-trash
        { label: 'Show Rails', icon: 'fa-fw fa-solid fa-eye', command: () => props.showRails(props.dataItem) },
        { label: 'Attach Rails', icon: 'pi pi-fw pi-link', command: () => props.attachRails(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.PAGE,
            path: ('/home/AuditLog' + "?module=" + MODULE.PAGE + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Name)
          })
        },
      ]
    }
  ]
  return menu;
}

export const collectionWithoutCommandMenuModel = (props) => {

  const menu = [
    {
      label: 'Options Not Available',
    }
  ]

  return menu;
}

export const collectionPlanningLockScheduleMenuModel = (props) => {

  const menu = [
    { label: 'Force Unlock', icon: 'pi pi-fw pi-lock-open', command: () => props.onForceUnlock(props.dataItem) },
  ]

  return menu;
}

export const collectionAnnouncementReconcileMenuModel = (props) => {

  const menu = [
    { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, prevPath: `&index=${props.dataIndex}` }) },
    { label: `${props.dataItem.BookingStatusSID._id == BOOKINGSTATUS.None ? 'Reconcile' : 'Not Reconcile'}`, icon: 'pi pi-fw pi-sync', command: () => props.reconcile({ ...props.dataItem }) },
  ]

  return menu;
}

export const exportTemplateMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Set As Default', icon: 'pi pi-fw pi-check-circle', command: () => props.setAsDefault(props.dataItem) }
      ]
    }
  ]
  return menu;
}

export const collectionRailsMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: 'Show Campaign', icon: 'pi pi-fw pi-eye', command: () => props.showOttCampaign(props.dataItem) },
        { label: 'Attach Campaign', icon: 'pi pi-fw pi-link', command: () => props.attachCampaign(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.RAILS,
            path: ('/home/AuditLog' + "?module=" + MODULE.RAILS + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
      ]
    }
  ]
  return menu;
}

export const collectionSegmentMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.onEdit(props.dataItem), disabled: props.dataItem.IsFromMaM },
        { label: 'Remove Segment', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.removeSegment(props.dataItem), () => { }) },
        { label: 'Add Segement QC', icon: 'pi pi-fw pi-sitemap', command: () => props.onAddSegmentQC(props.dataItem) },
        { label: 'History', icon: 'pi pi-fw pi-history', command: () => props.history(props.dataItem) },
        { label: 'Export', icon: 'pi pi-fw pi-file-excel', command: () => props.onExport(props.dataItem) },
        { label: 'Attach MAM', icon: 'pi pi-fw pi-link', command: () => props.attachMAM(props.dataItem) },
        { label: 'Show MAM', icon: 'pi pi-fw pi-video', command: () => props.showMAM(props.dataItem) },
        { label: 'Extension', icon: 'pi pi-fw pi-external-link', command: () => props.addExtension(props.dataItem) },
        { label: 'Create Transmission', icon: 'fa fa-lg fa-fw fa-tower-broadcast', command: () => props.onCreateTransmission(props.dataItem) },
        { label: 'Show Transmission', icon: 'fa fa-lg fa-fw fa fa-window-restore', command: () => props.onShowTransmission(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionMovieMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        // { label: 'Ott Package Delivery Schedule', icon: "pi pi-fw pi-flag-fill ", command: () => props.ottPackageDeliverySchedule({ ...props.dataItem, mmcAndMec: false, history: false }) },
        { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.MEDIA_EPISODE_MOVIE,
            path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_MOVIE + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        { label: 'Planning logs', icon: 'pi pi-fw pi-external-link', command: () => props.planningLogs(props.dataItem) },
        {
          label: 'Export',
          icon: 'pi pi-fw pi-folder',
          items: [
            { label: 'MEC', icon: "pi pi-fw pi-file-arrow-up", command: () => props.exportMECXML({ ...props.dataItem, exportMEC: true, history: false }) },
            { label: 'MMC', icon: "pi pi-fw pi-file-arrow-up", command: () => props.exportMMCXML({ ...props.dataItem, mmcAndMec: true, history: false }) },
            { label: 'XML', icon: 'pi pi-fw pi-file-arrow-up', command: () => props.onExportXML({ ...props.dataItem, history: false }) },
            { label: 'BXF', icon: 'pi pi-fw pi-file-arrow-up', command: () => props.onExportBXFXML({ ...props.dataItem, history: false }) },
            { label: 'Segments', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportSegmentationData({ ...props.dataItem, history: false }) },
          ]
        },
        { label: 'Transmissions', icon: 'pi pi-fw pi-sitemap', command: () => props.onShowTransmissions(props.dataItem) },
        { label: 'Setting', icon: "pi pi-fw pi-cog", command: () => props.mediaEpisodeSetting(props.dataItem) },
        isAutoCreateMAMAssetOnVersion && { label: 'Ingest MAM ( WO )', icon: 'pi pi-fw pi-file-excel', command: () => props.createMAMAssetAndWO(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionBreakMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.MEDIA_EPISODE_BREAK,
            path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_BREAK + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
      ]
    }
  ]
  return menu;
}

export const collectionDummyMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.MEDIA_EPISODE_DUMMY,
            path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_DUMMY + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
      ]
    }
  ]
  return menu;
}

export const collectionMediaEpisodeGroupMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        props?.module && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        }
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionMediaInterstitialModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Show Schedule', icon: 'pi pi-fw pi-external-link', command: () => props.onShowSchedule(props.dataItem) },
        props?.module && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        },
        { label: 'Attach MAM', icon: 'pi pi-fw pi-link', command: () => props.onAttachMAM(props.dataItem) },
        props?.module == MODULE.MEDIA_EPISODE_COMMERCIAL && { label: 'Preview', icon: "pi pi-fw pi-eye", command: () => props.onCommercialPreview(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionProgramMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Fast Segmentation', icon: "pi pi-fw pi-bolt", command: () => props.onFastSegmentation({ ...props.dataItem }) },
        props?.module == MODULE.MEDIA_EPISODE_PROGRAM && { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        { label: 'Planning logs', icon: 'pi pi-fw pi-external-link', command: () => props.planningLogs(props.dataItem) },
        // { label: 'Export Seg.', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportSegmentationData({ ...props.dataItem, history: false }) },
        // { label: 'Export XML', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportXML({ ...props.dataItem, history: false }) },
        {
          label: 'Export',
          icon: 'pi pi-fw pi-folder',
          items: [
            { label: 'MEC', icon: "pi pi-fw pi-file-arrow-up", command: () => props.exportMECXML({ ...props.dataItem, exportMEC: true, history: false }) },
            { label: 'MMC', icon: "pi pi-fw pi-file-arrow-up", command: () => props.exportMMCXML({ ...props.dataItem, mmcAndMec: true, history: false }) },
            { label: 'XML', icon: 'pi pi-fw pi-file-arrow-up', command: () => props.onExportXML({ ...props.dataItem, history: false }) },
            { label: 'BXF', icon: 'pi pi-fw pi-file-arrow-up', command: () => props.onExportBXFXML({ ...props.dataItem, history: false }) },
            { label: 'Segments', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportSegmentationData({ ...props.dataItem, history: false }) },
          ]
        },
        { label: 'Transmissions', icon: 'pi pi-fw pi-sitemap', command: () => props.onShowTransmissions(props.dataItem) },
        { label: 'Setting', icon: "pi pi-fw pi-cog", command: () => props.mediaEpisodeSetting(props.dataItem) },
        isAutoCreateMAMAssetOnVersion && { label: 'Ingest MAM ( WO )', icon: 'pi pi-fw pi-file-excel', command: () => props.createMAMAssetAndWO(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionDigitalSignScreenMenuModel = (props) => {
  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false }) },
        { label: 'Attach group', icon: 'pi pi-fw pi-link', command: () => props.onAttachGroup(props.dataItem) },
        { label: 'New group from screen', icon: 'pi pi-fw pi-link', command: () => props.onNewGroupCreate(props.dataItem) },
        { label: 'Show last play item', icon: 'pi pi-fw pi-external-link', command: () => props.onLastPlayItem(props.dataItem) },
        { label: 'Show Asrun Report', icon: 'fa fa-tasks fa-lg', command: () => props.onAsrunReport(props.dataItem) },
        { label: 'Show Error Log', icon: 'fa fa-exclamation-triangle fa-lg', command: () => props.onAsrunErrorReport(props.dataItem) },
        { label: 'Show Restart History', icon: 'fa fa-history fa-lg', command: () => props.onShowRestartHistory(props.dataItem) },
        { label: 'Restart Screen', icon: 'pi pi-fw pi-power-off', command: () => props.onRestart(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => props.onDelete(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionPlaylistMenuModel = (props) => {

  let playlistMenu = PlaylistHelper.getPlaylistMenu(props);

  const menu = [
    {
      label: 'Options',
      items: playlistMenu.filter(Boolean)
    }
  ]
  return menu;
}

export const collectionMenuModelWithDelete = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
      ]
    }
  ]
  return menu;
}

export const collectionCompanyMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
        { label: 'Show Details', icon: 'pi pi-fw pi-sliders-h', command: () => props.showDetails(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionJobScheduleMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: props.dataItem.Disable ? "Run" : 'Stop', icon: props.dataItem.Disable ? 'pi pi-fw pi-play' : 'pi pi-fw pi-stop-circle', command: () => props.handleStartStopJob({ ...props.dataItem }) },
        { label: "Show Jobs", icon: 'pi pi-fw pi-bars', command: () => props.showJobs({ ...props.dataItem }) },
        { label: "Test Run Job", icon: 'pi pi-fw pi-cog', command: () => props.showTestJobPopup({ ...props.dataItem }) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionPosterMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  let showLogs = props.showLogs ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        showLogs && {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props?.dataItem?._id + "&title=" + (props?.dataItem?.Title != undefined ? props?.dataItem?.Title : props?.dataItem?.Description != undefined ? props?.dataItem?.Description : props?.dataItem?.Name))
          })
        },
        { label: 'Preview', icon: 'pi pi-fw pi-eye', command: () => props.onPreview(props.dataItem) },
        { label: "Copy URL", icon: "fa-solid fa-clone", command: () => props.onCopyURL(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionPlaylistScheduleMenuModel = (props) => {

  let playlistMenu = PlaylistHelper.getPlaylistScheduleMenu(props);

  const menu = [
    {
      label: 'Options',
      items: playlistMenu.filter(Boolean)
    }
  ]
  return menu;
}

export const collectionSMCampaignMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Insight', icon: 'pi pi-fw pi-info-circle', command: () => props.onInsight(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const SMAdsMenuModel = (props) => {

  const archive = props.dataItem?.Archive ?? false;
  const showLogs = props.showLogs ?? false;

  return [
    {
      label: 'Edit',
      icon: 'pi pi-fw pi-pencil',
      command: () => props.enterEdit?.({
        ...props.dataItem,
        copy: false,
        prevPath: `&index=${props.dataIndex}`,
      }),
    },
    {
      label: archive ? 'Un-Archive' : 'Archive',
      icon: 'pi pi-fw pi-inbox',
      command: () => props.onArchive?.(props.dataItem),
    },
    {
      label: 'Create From',
      icon: 'pi pi-fw pi-copy',
      command: () => props.enterEdit?.({
        ...props.dataItem,
        SID: props.openNewEditForm ? props.dataItem.SID : 0,
        _id: props.openNewEditForm ? props.dataItem._id : null,
        copy: true,
        prevPath: `&index=${props.dataIndex}`,
      }),
    },
    showLogs && {
      label: 'Show logs',
      icon: 'pi pi-fw pi-external-link',
      command: () => {
        props.toNavigate?.({
          Module: props.module,
          path: `/home/AuditLog?module=${props.module}&_id=${props.dataItem?._id}&title=${props.dataItem?.Title || props.dataItem?.Description || props.dataItem?.Name}`,
        });
      },
    },
    {
      label: 'Share',
      icon: 'pi pi-fw pi-share-alt',
      items: [
        {
          label: 'Meta',
          icon: 'fab fa-meta',
          command: () => props.onSMSharePostMeta(props?.dataItem),
        },
        {
          label: 'Google',
          icon: 'fab fa-google',
          command: () => props.onSMSharePostGoogle(props?.dataItem),
        },
        {
          label: 'linkedin',
          icon: 'fab fa-linkedin',
          command: () => props.onSMSharePostLinkedIn(props?.dataItem),
        },
        {
          label: 'YouTube',
          icon: 'fab fa-youtube',
          command: () => props.onSMSharePostYouTube(props?.dataItem),
        },
        {
          label: 'Snapchat',
          icon: 'fab fa-snapchat',
          command: () => props.onSMSharePostSnapChat(props?.dataItem),
        },
      ],
    },
  ].filter(Boolean);
};

export const collectionDaiChannelMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.onDelete(props.dataItem), () => { }) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: MODULE.DAI_CHANNEL,
            path: ('/home/AuditLog' + "?module=" + MODULE.DAI_CHANNEL + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Name)
          })
        },
      ]
    }
  ]
  return menu;
}

export const globalSearchProgramMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const menu = [
    { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
    { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
    { label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => props.enterEdit({ ...props.dataItem, copy: true, prevPath: `&index=${props.dataIndex}` }) },
    { label: 'Segmentation Export', icon: 'pi pi-fw pi-file-excel', command: () => props.onExportSegmentationData({ ...props.dataItem, history: false }) },
    {
      label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
        Module: MODULE.MEDIA_EPISODE_PROGRAM,
        path: ('/home/AuditLog' + "?module=" + MODULE.MEDIA_EPISODE_PROGRAM + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
      })
    },
  ]
  return menu;
}

export const TransmissionTypeMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  let isDefault = props?.dataItem?.IsDefault ? props?.dataItem?.IsDefault : false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'Set As Default', icon: 'pi pi-fw pi-check-circle', command: () => props.setAsDefault(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const collectionMediaMamAssetMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Show Mam Asset', icon: 'pi pi-fw pi-eye', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        // { label: 'Re-Ingest', icon: 'pi pi-fw pi-angle-double-down', command: () => props.onReIngestMAM({ ...props.dataItem }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
        { label: 'Show Attached Media', icon: 'pi pi-fw pi-paperclip', command: () => props.OnShowAttachedMadia(props.dataItem) },
      ]
    }
  ]
  return menu;
}

export const trailerMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: 'Quick Edit', icon: 'fa-fw fa-solid fa-pen-to-square', command: () => props.enterEdit({ ...props.dataItem, quickEdit: true, history: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) },
        { label: 'History', icon: "pi pi-fw pi-history", command: () => props.history({ ...props.dataItem, history: true }) },
        { label: 'Fast Segmentation', icon: "pi pi-fw pi-bolt", command: () => props.onFastSegmentation({ ...props.dataItem }) },
        props?.module == MODULE.MEDIA_EPISODE_PROGRAM && { label: 'Deal Rights', icon: "pi pi-fw pi-play", command: () => props.publishingDealRights(props.dataItem) },
        {
          label: 'Show logs', icon: 'pi pi-fw pi-external-link', command: () => props.toNavigate({
            Module: props?.module,
            path: ('/home/AuditLog' + "?module=" + props?.module + "&_id=" + props.dataItem._id + "&title=" + props.dataItem.Title)
          })
        },
        isAutoCreateMAMAssetOnVersion && { label: 'Ingest MAM ( WO )', icon: 'pi pi-fw pi-file-excel', command: () => props.createMAMAssetAndWO(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionOfferMenuModel = (props) => {

  let archive = props.dataItem == undefined ? false : props.dataItem.Archive ?? false;
  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.enterEdit({ ...props.dataItem, copy: false, prevPath: `&index=${props.dataIndex}` }) },
        { label: archive ? 'Un-Archive' : 'Archive', icon: 'pi pi-fw pi-inbox', command: () => props.onArchive(props.dataItem) }, // pi-trash
        {
          label: 'Create From', icon: 'pi pi-fw pi-copy', command: () => {
            //alert(props.openNewEditForm);
            props.enterEdit({ ...props.dataItem, SID: props.openNewEditForm ? props.dataItem.SID : 0, _id: props.openNewEditForm ? props.dataItem._id : null, copy: true, prevPath: `&index=${props.dataIndex}` });
          }
        },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const offerTabMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.onEdit(props.dataItem, props.dataIndex) },
        { label: 'Remove Offer', icon: 'pi pi-fw pi-trash', command: () => ConfirmDeleteAlert(() => props.removeOffer(props.dataItem, props.dataIndex), () => { }) },
        props?.dataItem?.Status == TRANSMISSION_PUBLISH_STATUS.Published ? { label: 'Un-Publish Offer', icon: 'pi pi-fw pi-file', command: () => props.onUnPublishOffer(props.dataItem, props.dataIndex) } : { label: 'Publish Transmission', icon: 'pi pi-fw pi-history', command: () => props.publishTransmisson([props.dataItem]) },
        { label: 'Transmissions', icon: 'pi pi-fw pi-sitemap', command: () => props.onShowTransmissions(props.dataItem) },
      ]
    }
  ].filter(Boolean)
  return menu;
}

export const collectionMenuModelAssetOfferLink = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => props.onEdit(props.dataItem) },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => props.onDelete(props.dataItem, props.dataIndex) },
      ].filter(Boolean)
    }
  ]

  return menu;
}

export const collectionMenuModelTransmission = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        {
          label: "Edit",
          icon: 'fa fa-solid fa-pencil',
          command: () => props.onEdit(props.dataItem)
        },
        {
          label: "Edit Action",
          icon: 'fa fa-solid fa-edit',
          command: () => props.onEditAction(props.dataItem)
        },
        {
          label: "Update Series Transmission",
          icon: 'fa fa-solid fa-list-ol',
          command: () => props.onEditSeriesTransmission(props.dataItem)
        },
        {
          label: "Update Node",
          icon: 'fa fa-solid fa-folder',
          command: () => props.updateNode(props.dataItem)
        },
        {
          label: "Add Offer",
          icon: 'fa fa-solid fa-plus',
          command: () => props.onAddOffer(props.dataItem)
        },
        {
          label: "Show Offers",
          icon: 'fa fa-solid fa-external-link-square',
          command: () => props.showOffers(props.dataItem)
        },
        {
          label: "Show Media",
          icon: 'fa fa-solid fa-image',
          command: () => props.showMedia(props.dataItem)
        },
        {
          label: "Show MAM Asset",
          icon: 'fa fa-solid fa-video',
          command: () => props.showMamAsset(props.dataItem)
        },
        {
          label: "Open Node Browser",
          icon: 'fa fa-solid fa-external-link',
          command: () => props.openNodeBrowser(props.dataItem)
        },
        {
          label: "Reset Thumbnail Status",
          icon: 'pi pi-fw pi-refresh',
          command: () => props.resetThumbnailStatus(props.dataItem)
        },
        {
          label: "Mark as Verified",
          icon: 'pi pi-fw pi-check-circle',
          command: () => props.markAsVerified(props.dataItem)
        },
        {
          label: "Reset Verified Status",
          icon: 'pi pi-fw pi-times-circle',
          command: () => props.resetVerifiedStatus(props.dataItem)
        },
        {
          label: "Delete",
          icon: 'fa fa-solid fa-trash',
          command: () => props.onDelete(props.dataItem)
        }
      ].filter(Boolean)
    }
  ]

  return menu;
}

export const VersionBrowserMenuModel = (props) => {

  const menu = [
    {
      label: 'Options',
      items: [
        { label: 'Show Transmission', icon: 'fa fa-lg fa-fw fa fa-window-restore', command: () => props.onShowTransmission(props.dataItem) },
        props?.dataItem?.MediaEpisode?.MediaCategory?.SID == MEDIACATEGORIES.Episode && { label: 'Create Series Transmission', icon: 'fa fa-lg fa-fw fa-list-ol', command: () => props.onCreateSeriesTransmission(props.dataItem) },
        { label: 'Create Transmission', icon: 'fa fa-lg fa-fw fa-tower-broadcast', command: () => props.onCreateTransmission(props.dataItem) },
        { label: 'Show Media', icon: 'pi pi-fw pi-eye', command: () => props.onShowMedia(props.dataItem) },
        { label: 'Segment Extension', icon: 'fa fa-solid fa-external-link-square', command: () => props.addSegmentExtension(props.dataItem) },
      ].filter(Boolean)
    }
  ]
  return menu;
}

export const collectionMenuModelVODReport = (props) => {
  const menu = [
    {
      label: 'Options',
      items: [
        {
          label: "Mark as Verified",
          icon: 'pi pi-fw pi-check-circle',
          command: () => props.markAsVerified(props.dataItem)
        },
        {
          label: "Reset Verified Status",
          icon: 'pi pi-fw pi-times-circle',
          command: () => props.resetVerifiedStatus(props.dataItem)
        }
      ].filter(Boolean)
    }
  ]
  return menu;
}
